import { NarutoItem } from "@/interfaces/CardItem";
import _ from "lodash";
import { IFiltersNaruto } from "@/components/DeckBuilder/game/naruto/filters/getDefaultFilters";
import { DeckCardsMap } from "@/lib/games/onePiece/DeckCommonCardsFilter";

export function filterCards(
  baseSortedCards: NarutoItem[],
  filters: IFiltersNaruto,
  defaultFilters: IFiltersNaruto,
  deckCardsMap: DeckCardsMap,
): NarutoItem[] {
  let filteredCards: NarutoItem[] = [];

  if (_.isEqual(filters, defaultFilters)) {
    return baseSortedCards;
  }

  for (const card of baseSortedCards) {
    let shouldAdd = true;

    // Name/Effect filter
    if (filters.search !== "") {
      if (shouldAdd) {
        if (filters.searchSelect.has("name")) {
          shouldAdd = card.name
            .toLowerCase()
            .includes(filters.search.toLowerCase());
        } else if (filters.searchSelect.has("effect")) {
          shouldAdd = (card.effect || "")
            .toLowerCase()
            .includes(filters.search.toLowerCase());
        } else if (filters.searchSelect.has("traits")) {
          shouldAdd = (card.traits || []).some((trait) =>
            trait.toLowerCase().includes(filters.search.toLowerCase()),
          );
        } else {
          // check everything
          shouldAdd =
            card.name.toLowerCase().includes(filters.search.toLowerCase()) ||
            (card.effect || "")
              .toLowerCase()
              .includes(filters.search.toLowerCase()) ||
            card.card_type
              .toLowerCase()
              .includes(filters.search.toLowerCase()) ||
            card.id.toLowerCase().includes(filters.search.toLowerCase()) ||
            (card.traits || []).some((trait) =>
              trait.toLowerCase().includes(filters.search.toLowerCase()),
            );
        }
      }
    }

    // Symbol (color) filter
    if (filters.symbol.size !== 0) {
      const symbolsToSearch = Array.from(filters.symbol);
      const curSymbols = (card.color || "")
        .split("/")
        .map((element: string) => element.toLowerCase());
      shouldAdd =
        shouldAdd &&
        curSymbols.some((symbol: string) => symbolsToSearch.includes(symbol));
    }

    // Chakra cost filter
    if (filters.entranceCost.size !== 0) {
      const curCost = String(card.chakra_cost ?? 0);
      shouldAdd = shouldAdd && filters.entranceCost.has(curCost);
    }

    // Power filter
    if (filters.combat.size !== 0) {
      const curPow = String(card.pow ?? 0);
      shouldAdd = shouldAdd && filters.combat.has(curPow);
    }

    // Damage filter
    if (filters.support.size !== 0) {
      const curDmg = String(card.dmg ?? 0);
      shouldAdd = shouldAdd && filters.support.has(curDmg);
    }

    // Card type filter
    if (filters.cardType.size !== 0) {
      shouldAdd = shouldAdd && filters.cardType.has(card.card_type);
    }

    // Traits filter (formerly characteristics)
    if (filters.characteristics.size !== 0) {
      const traitsToSearch = Array.from(filters.characteristics);
      shouldAdd =
        shouldAdd &&
        (card.traits || []).some((trait: string) =>
          traitsToSearch.includes(trait),
        );
    }

    // Set filter
    if (
      filters.set !== "" &&
      filters.set !== undefined &&
      filters.set !== null
    ) {
      shouldAdd = shouldAdd && card.id.includes(filters.set);
    }

    // Lang filter
    if (filters.lang.size !== 0) {
      const vals: string[] = Array.from(filters.lang) as string[];
      if (vals.length === 1) {
        shouldAdd = shouldAdd && card.src === vals[0];
      }
    }

    if (shouldAdd) {
      filteredCards.push(card);
    }
  }

  return filteredCards;
}
